import React from 'react';
import ajax from '../../../ajax';
import functions from '../../../functions';
import DashCard from '../../Common/DashCard';


class PendingDeposits extends React.Component {
  

  state={
    userId:functions.sessionGuard(),
    accessInfo:false,
    balance:'...',
    total:'...'
   
  }


    async componentDidMount()
    {
      await this.getActualBalance();
      this.timerActual = setTimeout(this.func1=async()=> {
        await this.getActualBalance();
        this.timerActual = setTimeout(this.func1, 2000); // (*)
      }, 2000);

    }

    componentWillUnmount()
    {
      clearTimeout(this.timerActual);
    }

    getActualBalance=async()=>{
      const server_response=await ajax.countPendingTopups();
      if(server_response.status==="OK")
      {
        this.setState({
          balance:server_response.details.total_p
        })
      }
    }





  render(){
      return (
        <DashCard 
            title="Pending Topups"
            value={this.state.balance}
            caption={"Pending Approval -> Processing"}
            icon={"fas fa-hourglass-half text-warning"}
            progressbar={"bg-warning"}
            />

      );
    
 
  }
}

export default PendingDeposits;